export default __webpack_public_path__ + "static/media/check.67214877.svg";